<template>
  <!-- Setting group to a value allows cross list dragging -->
  <draggable
    :list="items"
    :move="moveItem"
    :disabled="readonly"

    :group="settings.isAI ? undefined : 'dialogue'"
    handle=".draggable"
    @start="startDrag"
    @end="endDrag"
  >
    <li
      v-for="item of items" :key="item.id"
      data-testid="dialogue-item-container"
    >
      <dialogue-item
        :key="item.id"
        :settings="settings"
        :item="item"
        :is-child="!!parent"
        :drag-message="dragMessage"
        :readonly="readonly"
        :errors="errorsById[item.id]"
        :warnings="warningsById[item.id]"
        @editQuestion="editQuestion"
        @editAnswer="editAnswer"
        @editResponse="editResponse"
        @editReason="editReason"
        @playAudio="playAudio"
        @editEnabled="editEnabled"
        @remove="remove"
      />
      <dialogue-list
        v-if="item.children"
        class="child-item"
        :settings="settings"
        :items="item.children"
        :parent="item"
        :readonly="readonly"
        :errors="errors"
        :warnings="warnings"
        data-testid="child-dialogue-list-container"
        @startDrag="startDrag"
        @dropItem="dropItem"
        @editQuestion="editQuestion"
        @editAnswer="editAnswer"
        @editResponse="editResponse"
        @editReason="editReason"
        @playAudio="playAudio"
        @editEnabled="editEnabled"
        @remove="remove"
      />
    </li>
  </draggable>
</template>

<script>
import Draggable from 'vuedraggable';
import { groupBy } from 'lodash';

import DialogueItem from './DialogueItem';

export default {
  name: 'dialogue-list',
  components: {
    Draggable,
    DialogueItem,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    dragMessage: {
      type: String,
      default: null,
    },
    parent: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: undefined,
    },
    warnings: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    errorsById() {
      return groupBy(this.errors, 'metadata.componentId');
    },
    warningsById() {
      return groupBy(this.warnings, 'metadata.componentId');
    },
  },
  methods: {
    startDrag() {
      this.$emit('startDrag');
    },
    endDrag(evt) {
      const item = evt.item._underlying_vm_;
      this.dropItem(item)
    },
    moveItem(evt) {
      // Return true to approve the move, false to reject it
      const context = evt.draggedContext;

      // Is being dragged to a new (unsaved) list
      const isNewParentUnsaved = (evt.relatedContext.list[0].parent && evt.relatedContext.list[0].parent.isNew);
      if (isNewParentUnsaved) {
        return false;
      }

      // Is the item being moved a parent
      const hasChildren = !!(context.element.children && context.element.children.length);

      // Would the item being moved become a child
      const wouldBeChild = !evt.relatedContext.list[0].children;
      if (hasChildren && wouldBeChild) {
        return false; // don't allow nesting of parents in children
      }
      return true;
    },
    dropItem(item) {
      this.$emit('dropItem', item);
    },
    editQuestion(item, value) {
      this.$emit('editQuestion', item, value);
    },
    editAnswer(item, value) {
      this.$emit('editAnswer', item, value);
    },
    editResponse(item, value) {
      this.$emit('editResponse', item, value);
    },
    editReason(item, value) {
      this.$emit('editReason', item, value);
    },
    playAudio(item) {
      this.$emit('playAudio', item);
    },
    editEnabled(item, value) {
      this.$emit('editEnabled', item, value)
    },
    remove(item) {
      this.$emit('remove', item);
    }
  }
}
</script>

<style scoped>
li {
  list-style: none;
}
.child-list-item {
 list-style: circle;
}
.child-item {
  margin-left: 46px;
}
</style>